import { OnInit } from '@angular/core';
import { Product } from '../../../core/models/product';
import * as moment from 'moment';
var StockInfoComponent = /** @class */ (function () {
    function StockInfoComponent() {
        this.layout = 'compact';
    }
    StockInfoComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(StockInfoComponent.prototype, "firstAvailableStock", {
        get: function () {
            if (this.product && this.product.stock && this.product.stock.length) {
                var currentStock = this.product.stock.find(function (stock) { return stock.type === 'current'; });
                var futureStock = this.product.stock.filter(function (stock) { return stock.type === 'future'; });
                if (currentStock && currentStock.quantity) {
                    return currentStock;
                }
                if (futureStock && futureStock.length) {
                    futureStock = futureStock.sort((function (a, b) {
                        if (a.date < b.date)
                            return -1;
                        if (a.date > b.date)
                            return 1;
                        return 0;
                    }));
                    var firstAvailableFutureStock = futureStock[0];
                    return firstAvailableFutureStock;
                }
            }
            // No stock (return null)
            return;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StockInfoComponent.prototype, "isCompactLayout", {
        get: function () {
            return this.layout === 'compact';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StockInfoComponent.prototype, "isInCurrentStock", {
        get: function () {
            var stock = this.firstAvailableStock;
            if (stock) {
                return stock.type === 'current';
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StockInfoComponent.prototype, "isInFutureStock", {
        get: function () {
            var stock = this.firstAvailableStock;
            if (stock) {
                return stock.type === 'future';
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StockInfoComponent.prototype, "isOutOfStock", {
        get: function () {
            var stock = this.firstAvailableStock;
            if (!stock) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StockInfoComponent.prototype, "quantity", {
        get: function () {
            var stock = this.firstAvailableStock;
            if (stock) {
                return stock.quantity;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StockInfoComponent.prototype, "week", {
        get: function () {
            var stock = this.firstAvailableStock;
            if (stock && stock.type === 'future') {
                var date = moment(stock.date);
                if (date.isValid()) {
                    return date.format('w');
                }
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    return StockInfoComponent;
}());
export { StockInfoComponent };
